// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__1D4NP","Success":"Button_Success__1ETpU","Danger":"Button_Danger__2wKfE"};